export default __webpack_public_path__ + "static/ism-home-mobile2-0501e7fde91d4eb6f052ed98180658ca.png";